
export const fields = [
    {
      name:'Section A',
      label:'SECTION A: Trials',
      type:'label',
      layout:'col s12 section-title',
      anchorLink:{
        status: true,
        id:'sectionA'
      }
    },
    {
      name:'01_trials_scheduled_label',
      label:'1. Number of trials scheduled:',
      type:'label',
      layout:'col s12',
    },
    {/*  */
       name:'01_trials_scheduled_civil_label',
       label:'1. Number of trials scheduled (Civil):',
       type:'label',
       layout:'col s12 hide',
     },
    {
      name:'01_trials_scheduled_civil',
      label:'Civil',
      type:'number',
      values:'',
      readonly:false,
      layout:'col s6 input-field',
    },
    {/*  */
       name:'01_trials_scheduled_commercial_label',
       label:'1. Number of trials scheduled (commercial):',
       type:'label',
       layout:'col s12 hide',
     },
    {
      name:'01_trials_scheduled_commercial',
      label:'Commercial',
      type:'number',
      values:'',
      readonly:false,
      layout:'col s6 input-field',
    },
     /* -- */
    {
      name:'02_trials_completed_disposed_label',
      label:'2. Number of trials completed/disposed:',
      type:'label',
      layout:'col s12',
    },
    {/*  */
       name:'02_trials_completed_disposed_civil_label',
       label:'2. Number of trials completed/disposed (civil):',
       type:'label',
       layout:'col s12 hide',
     },
    {
      name:'02_trials_completed_disposed_civil',
      label:'Civil',
      type:'number',
      values:'',
      readonly:false,
      layout:'col s6 input-field',
    },
    {/*  */
      name:'02_trials_completed_disposed_commercial_label',
      label:'2. Number of trials completed/disposed (commercial)',
      type:'label',
      layout:'col s12 hide',
    },
    {
      name:'02_trials_completed_disposed_commercial',
      label:'Commercial',
      type:'number',
      values:'',
      readonly:false,
      layout:'col s6 input-field',
    },
   /* -- */
    {
      name:'02_b_method_of_completion_of_each_trial_label',
      label:'2 (b) Method of completion of each trial in 2(a)',
      type:'label',
      values:'',
      readonly:false,
      layout:'col s12 input-field',
    },
  {
  name:'02_b_method_of_completion_of_each_trial',
  label:'',
  type:'data_table',
  add_placeholder:'Reason',
  header:['Method of completion', 'Number'],
  add_button_caption: 'Add Reasons',
  other_label: `<span class="blue-text text-accent-4">State additional reasons</span`,
  show_total: true,
  values:[
    { 
      reason: "Trial and oral decision issued",
      total: 0,
    },
    { 
      reason: "Trial and written decision issued",
      total: 0,
    },
    { 
      reason: "Trial and oral decision with written reasons issued ",
      total: 0,
    },
    { 
      reason: "Trial and reserved decision* trial completed but matter not disposed",
      total: 0,
    },
    { 
      reason: "Consent Order* state in the comments how many were done before the scheduled trial was held",
      total: 0,
    },
    { 
      reason: "Settlement following JSC",
      total: 0,
    },
    { 
      reason: "Settlement following Mediation",
      total: 0,
    },
    { 
      reason: "Claim withdrawn",
      total: 0,
    },
    { 
      reason: "Withdrawn /Discontinued (other)",
      total: 0,
    },
   
  ],
  can_add: true,
  readonly:false,
  layout:'col s12',
},
/*  */
{
  name:'3_a_number_of_trials_adjourned_label',
  label:'3 (a) Total number of trials adjourned: ',
  type:'label',
  layout:'col s12',
},
{/*  */
  name:'3_a_number_of_trials_adjourned_civil_label',
  label:'3 (a) Number of trials adjourned (Civil)',
  type:'label',
  layout:'col s12 hide',
},
{
  name:'3_a_number_of_trials_adjourned_civil',
  label:'Civil',
  type:'number',
  values:'',
  readonly:false,
  layout:'col s6 input-field',
},
{/*  */
  name:'3_a_number_of_trials_adjourned_commercial_label',
  label:'3 (a) Number of trials adjourned (Commercial)',
  type:'label',
  layout:'col s12 hide',
},
{
  name:'3_a_number_of_trials_adjourned_commercial',
  label:'Commercial',
  type:'number',
  values:'',
  readonly:false,
  layout:'col s6 input-field',
},
/*  */
{
  name:'3_b_how_many_adjourned_trials_were_part_heard',
  label:` &nbsp; &nbsp; (b) Out of the total in 3(a); how many of these adjourned trials were part heard?`,
  type:'label',
  layout:'col s12',
},
{/*  */
  name:'3_b_how_many_adjourned_trials_were_part_heard_civil_label',
  label:'3 (b) How many <b>of the adjourned trials</b> were part heard (Civil)? ',
  type:'label',
  layout:'col s12 hide',
},
{
  name:'3_b_how_many_adjourned_trials_were_part_heard_civil',
  label:'Civil',
  type:'number',
  values:'',
  readonly:false,
  layout:'col s6 input-field ',
},
{/*  */
  name:'3_b_how_many_adjourned_trials_were_part_heard_commercial_label',
  label:'3 (b) How many <b>of the adjourned trials</b> were part heard (Commercial)',
  type:'label',
  layout:'col s12 hide',
},
{
  name:'3_b_how_many_adjourned_trials_were_part_heard_commercial',
  label:'Commercial',
  type:'number',
  values:'',
  readonly:false,
  layout:'col s6 input-field ',
},
/*  */
{
  name:'3_c_reasons_for_adjournments_label_',
  label:`&nbsp; &nbsp; 3 (c) Reasons for adjournments; for the trials in 3(a) only <br> &nbsp; &nbsp;  <span class="red-text">(Put one primary reason per adjourned trial only based on the first adjournment)</span>`,
  type:'label',
  layout:'col s12',
},
  {/*  */
  name:'3_c_reasons_for_adjournments_label',
  label:'3 (C) Reasons for adjournments',
  type:'label',
  layout:'col s12 hide',
  },
  {
  name:'3_c_reasons_for_adjournments',
  label:'',
  type:'data_table',
  add_placeholder:'Reason',
  header:['Reason', 'Number'],
  add_button_caption: 'Add Reasons',
  other_label: `<span class="blue-text text-accent-4">State additional reasons</span`,
  show_total: true,
  values:[
    { 
      reason: "Absence of attorney",
      total: 0,
    },
    { 
      reason: "Absence of party/parties",
      total: 0,
    },
    { 
      reason: "For further case management",
      total: 0,
    },
    { 
      reason: "For outcome of mediation",
      total: 0,
    },
    { 
      reason: "For report",
      total: 0,
    },
    { 
      reason: "For review",
      total: 0,
    },
    { 
      reason: "For settlement discussions",
      total: 0,
    },
    { 
      reason: "Unavailability of courtroom",
      total: 0,
    },
    { 
      reason: "Unavailability of dates",
      total: 0,
    },
    { 
      reason: "For further directions/order",
      total: 0,
    },
  ],
  can_add: true,
  readonly:false,
  layout:'col s12',
},
/*  */

{
  name:'3_d_how_many_trials_were_adjourned_label',
  label:`&nbsp; &nbsp; (d) How many trials were adjourned (more than once)?`,
  type:'label',
  layout:'col description drag-line',
},
{
  name:'3_d_how_many_trials_were_adjourned',
  label:'',
  type:'data_table',
  values:[
    {
      reason:"Two Times",
      total: 0,
    },
    {
      reason:"Three times",
      total: 0,
    },
    {
      reason:"Four times",
      total: 0,
    },
    {
      reason:"More than 4 times",
      total: 0,
    }
  ],
  can_add: false,
  readonly:false,
  layout:'col s12',
},

/*  */

{
  name:'3_e_what_were_the_primary_reasons_for_the_further_adjournment_label',
  label:`&nbsp; &nbsp; (e) What were the primary reasons for the further adjournments?`,
  type:'label',
  layout:'col 12',
},
{
  name:'3_e_what_were_the_primary_reasons_for_the_further_adjournment',
  label:'',
  type:'text_area',
  values:'',
  readonly:false,
  layout:'col s12',
},

/*  */

{
  name:'how_many_trials_have_lasted_label',
  label:'4. How many trials have lasted: (Please clearly indicate your responses)',
  type:'label',
  layout:'col description drag-line',
},
{
  name:'how_many_trials_have_lasted',
  label:'',
  type:'data_table',
  values:[
    {
      reason:"Up to 2 Days? (NB: 1 day or less fits in this category)",
      total: 0,
    },
    {
      reason:"Up to 5 Days?",
      total: 0,
    },
    {
      reason:"Up to 10 Days?",
      total: 0,
    },
    {
      reason:"More than 10 Days?",
      total: 0,
    }
  ],
  can_add: false,
  readonly:false,
  layout:'col s12',
},
/*  */
{
  name:'Section B',
  label:'SECTION B: JUDGMENTS AFTER TRIAL',
  type:'label',
  layout:'col s12 section-title',
  anchorLink:{
    status: true,
    id:'sectionB'
  }
},
/*  */
{
  name:'01_number_of_written_judgments_delivered_label',
  label:'1. Number of written judgments delivered',
  icon:{
    value:'help',
    active: true,
  },
  type:'label',
  layout:'col description drag-line',
},
{
  name:'01_number_of_written_judgments_delivered',
  label:'',
  type:'number',
  values:'',
  readonly:false,
  layout:'col number-value',
},
/*  */
{
  name:'02_number_of_oral_judgments_delivered_label',
  label:'2. Number of oral judgments delivered',
  type:'label',
  layout:'col description drag-line',
},
{
  name:'02_number_of_oral_judgments_delivered',
  label:'',
  type:'number',
  values:'',
  readonly:false,
  layout:'col number-value',
},
/*  */
{
  name:'Section C',
  label:'SECTION C: OPEN COURT AND CHAMBER MATTERS',
  type:'label',
  layout:'col s12 section-title',
  anchorLink:{
    status: true,
    id:'sectionC'
  }
},
/*  */
{
  name: '01_Number_of_matters_scheduled_listed_label',
  label: "1. Number of open court and chamber matters scheduled/listed",
  type:'label',
  layout:'col description drag-line',
},
 {
  name: '01_Number_of_matters_scheduled_listed',
  label:"",
  type:'number',
  values:'',
  readonly:false,
  layout:'col number-value',
},
/*  */
{
  name: '02_Number_of_matters_where_decisions_were_reserved_label',
  label: "2. Number of matters where decisions were reserved",
  type:'label',
  layout:'col description drag-line',
},
 {
  name: '02_Number_of_matters_where_decisions_were_reserved',
  label:"",
  type:'number',
  values:'',
  readonly:false,
  layout:'col number-value',
},
/*  */
{
  name: '03_Number_of_oral_decisions_delivered_label',
  label: "3. Number of oral decisions delivered",
  type:'label',
  layout:'col description drag-line',
},
 {
  name: '03_Number_of_oral_decisions_delivered',
  label:"",
  type:'number',
  values:'',
  readonly:false,
  layout:'col number-value',
},
/*  */
{
  name: '04_Number_of_written_decisions_delivered_label',
  label: "4. Number of written decisions delivered",
  type:'label',
  layout:'col description drag-line',
},
 {
  name: '04_Number_of_written_decisions_delivered',
  label:"",
  type:'number',
  values:'',
  readonly:false,
  layout:'col number-value',
},
/*  */
{
  name: '05_a_Reasons_for_adjournment_of_matters_label',
  label: `5. (a) Reasons for adjournment of matters <br><span class="red-text">(Enter values only for the first adjournment)</span>`,
  type:'label',
  layout:'col 12',
},
{
  name:'05_a_Reasons_for_adjournment_of_matters',
  label:'',
  type:'data_table',
  header:['Reason for adjournment', 'Number'],
  other_label: `<span class="blue-text text-accent-4">State additional reasons</span>`,
  add_placeholder:'Reason',
  add_button_caption: 'Add Reasons',
  show_total: true,
  values:[
    {
      reason: "Absence of attorney",
      total: 0,
    },
    {
      reason: "Absence of party/parties",
      total: 0,
    },
    {
      reason: "Bench warrant issued",
      total: 0,
    },
    {
      reason: "Defendant to retain counsel",
      total: 0,
    },
    {
      reason: "Due to lack of disclosure",
      total: 0,
    },
    {
      reason: "For directions/further directions/order",
      total: 0,
    },
    {
      reason: "For further case management",
      total: 0,
    },
    {
      reason: "For outcome of mediation",
      total: 0,
    },
    {
      reason: "For settlement discussions",
      total: 0,
    },
    {
      reason: "For review of terms of orders",
      total: 0,
    },
    {
      reason: "Stayed",
      total: 0,
    },
    {
      reason: "To allow for service on the claimant/defendant",
      total: 0,
    },
    {
      reason: "Unavailability of Courtroom",
      total: 0,
    },
    {
      reason: "Unavailability of dates",
      total: 0,
    },
    {
      reason: "Unavailability of judge",
      total: 0,
    },
  ],
  can_add: true,
  readonly:false,
  layout:'col s12',
},
/*  */

{
  name:'5_b_what_were_the_primary_reasons_for_any_further_adjournments_label',
  label:`&nbsp; &nbsp; (b) What were the primary reasons for any further adjournments`,
  type:'label',
  layout:'col 12',
},
{
  name:'5_b_what_were_the_primary_reasons_for_any_further_adjournments',
  label:'',
  type:'text_area',
  values:'',
  readonly:false,
  layout:'col s12',
},


/*  */
{
  name: '06_number_of_matters_completed_disposed_of_label',
  label: "6. Number of matters completed/disposed",
  type:'label',
  layout:'col 12',
},
{
  name:'06_number_of_matters_completed_disposed_of',
  label:'',
  type:'data_table',
  add_placeholder:'Method',
  add_button_caption: 'Add method',
  header:['Method of disposal', 'Number'],
  other_label: `<span class="blue-text text-accent-4">Additional methods of dispossal</span>`,
  show_total: true,
  values:[
    { 
      reason: "Consent Order",
      total: 0,
    },
    { 
      reason: "Discontinued/withdrawn",
      total: 0,
    },
    { 
      reason: "Dismissed for want of prosecution",
      total: 0,
    },
    { 
      reason: "Struck Out",
      total: 0,
    },
    { 
      reason: "Settled",
      total: 0,
    },
    { 
      reason: "Mediation Agreement",
      total: 0,
    },
    { 
      reason: "Satisfaction",
      total: 0,
    },
    { 
      reason: "Order Granted as Prayed",
      total: 0,
    },
    { 
      reason: "Application Refused",
      total: 0,
    },
    { 
      reason: "Matter Removed from the list",
      total: 0,
    },
  ],
  can_add: true,
  readonly:false,
  layout:'col s12',
},
/*  */
{
  name:'Section D',
  label:'SECTION D: DIVORCES',
  type:'label',
  layout:'col s12 section-title',
  anchorLink:{
    status: true,
    id:'sectionE'
  }
  },
  /*  */
  {   
    name:'1_Number_of_Divorce_matters_matrimonial_applications_scheduled_listed_label',
    label: "1. Number of Divorce matters/Matrimonial applications scheduled/listed",
    type:'label',
    layout:'col description drag-line',
  },
  {
    name:'1_Number_of_Divorce_matters_matrimonial_applications_scheduled_listed',
    label:'',
    type:'number',
    values:'',
    readonly:false,
    layout:'col number-value',
  },
  /*  */
  { 
    name:'2_Number_of_Divorce_matters_Matrimonial_applications_adjourned_label',
    label: "2. Number of Divorce matters/ Matrimonial applications adjourned",
    type:'label',
    layout:'col description drag-line',
  },
  {
    name:'2_Number_of_Divorce_matters_Matrimonial_applications_adjourned',
    label:'',
    type:'number',
    values:'',
    readonly:false,
    layout:'col number-value',
  },
  /*  */
  { 
    name:'3_Number_of_Decrees_Nisi_granted_label',
    label: "3. Number of Decrees Nisi granted",
    type:'label',
    layout:'col description drag-line',
  },
  {
    name:'3_Number_of_Decrees_Nisi_granted',
    label:'',
    type:'number',
    values:'',
    readonly:false,
    layout:'col number-value',
  },
  /*  */

  { 
    name:'4_Number_of_decrees_absolute_label',
    label: "4. Number of Decrees Absolute ",
    type:'label',
    layout:'col description drag-line',
  },
  {
    name:'4_Number_of_decrees_absolute',
    label:'',
    type:'number',
    values:'',
    readonly:false,
    layout:'col number-value',
  },

  /*  */
  { 
    name:'5_Number_of_Ancillary_matters_scheduled_listed_label',
    label: "5. Number of Ancillary matters scheduled/listed",
    type:'label',
    layout:'col description drag-line',
  },
  {
    name:'5_Number_of_Ancillary_matters_scheduled_listed',
    label:'',
    type:'number',
    values:'',
    readonly:false,
    layout:'col number-value',
  },
  /*  */
  { 
    name:'6_Number_of_Ancillary_matters_adjourned_label',
    label: "6. Number of Ancillary matters adjourned",
    type:'label',
    layout:'col description drag-line',
  },
  {
    name:'6_Number_of_Ancillary_matters_adjourned',
    label:'',
    type:'number',
    values:'',
    readonly:false,
    layout:'col number-value',
  },
  /*  */
  { 
    name:'07_Method_of_disposal_of_Ancillary_matters_label',
    label: "7. Method of disposal of Ancillary matters ",
    type:'label',
    layout:'col description drag-line',
  },
  {
    name:'07_Method_of_disposal_of_Ancillary_matters',
    label:'',
    type:'data_table',
    header:['Method of disposal', 'Number'],
    other_label: 'Addtional methods (state with numbers)',
    show_total: true,
    values:[
      {
        reason: "Consent Order * state in the comments how many were done without a hearing",
        total: 0
      },
      {
        reason: "Dismissed",
        total: 0
      },
      {
        reason: "Withdrawn",
        total: 0
      },
      {
        reason: "Discontinued",
        total: 0
      },
      {
        reason: "Settled",
        total: 0
      },
    /*   {
        reason: "Other (specify)",
        total: 0
      }, */
    ],
    can_add: true,
    readonly:false,
    layout:'col s12',
  },
  /*  */
  { 
    name:'08_Reasons_for_adjournment_for_all_Divorce_matters_Divorce_ancillary_etc_label',
    label: `8. Reasons for adjournment for all Divorce matters (Divorce, ancillary etc): <br> <span class="red-text">(Enter values only for the first adjournment)</span>`,
    type:'label',
    layout:'col description drag-line',
  },
  {
    name:'08_Reasons_for_adjournment_for_all_Divorce_matters_Divorce_ancillary_etc',
    label:'',
    type:'data_table',
    header:['Reason for adjournment', 'Total'],
    other_label: 'Addtional reasons (specify)',
    show_total: true,
    values:[
      {
        reason: "Absence of attorney",
        total: 0
      },
      {
        reason: "For discussion",
        total: 0
      },
      {
        reason: "For the parties to pursue voluntary mediation",
        total: 0
      },
      {
        reason: "Non -service of the respondent",
        total: 0
      },
      {
        reason: "For further directions",
        total: 0
      },
      {
        reason: "For trial",
        total: 0
      },
    ],
    can_add: true,
    readonly:false,
    layout:'col s12',
  },
  /*  */
  {
    name:'8_b_What_wer_the_primary_reason_for_any_further_adjournments_label',
    label:'(b) What were the primary reasons for any further adjournments?',
    type:'label',
    layout:'col 12',
  },
  {
    name:'8_b_What_wer_the_primary_reason_for_any_further_adjournments',
    label:'',
    type:'text_area',
    values:'',
    readonly:false,
    layout:'col s12',
},

  /*  */
  {
    name:'Section E',
    label:'SECTION E: APPLICATIONS WITHOUT NOTICE/EX- PARTE HEARINGS',
    type:'label',
    layout:'col s12 section-title',
    anchorLink:{
      status: true,
      id:'sectionF'
    }
    },
    /*  */
    { 
      name:'01_Number_of_applications_without_notice_dealt_with_label',
      label: "1. Number of applications without notice dealt with",
      type:'label',
      layout:'col description drag-line',
    },
    {
      name:'01_Number_of_applications_without_notice_dealt_with',
      label:'',
      type:'number',
      values:'',
      readonly:false,
      layout:'col number-value',
    },
    /*  */
  {
    name:'Section F',
    label:'SECTION F: APPLICATIONS REVIEWED AND MADE IN ADMINISTRATION OF ESTATES AND PROBATES',
    type:'label',
    layout:'col s12 section-title',
    anchorLink:{
      status: true,
      id:'sectionG'
    }
  },
  /*  */
  { 
    name:'01_Number_of_applications_dealt_with_in_this_regard_label',
    label: "1. Number of applications dealt with in review/administration of estates and probates",
    type:'label',
    layout:'col description drag-line',
  },
  {
    name:'01_Number_of_applications_dealt_with_in_this_regard',
    label:'',
    type:'number',
    values:'',
    readonly:false,
    layout:'col number-value',
  },
  /*  */
  {
    name:'Section G',
    label:'SECTION G: OTHER APPLICATIONS (example land certificate/Certificate of Title matters / Possessory titles / Rectification or Amendments of Civil Status Records)',
    type:'label',
    layout:'col s12 section-title',
    anchorLink:{
      status: true,
      id:'sectionH'
    }
  },
  /*  */
  { 
    name:'01_Number_of_applications_label',
    label: "1. Number of other applications",
    type:'label',
    layout:'col',
  },
  {
    name:'01_Number_of_applications',
    label:'',
    type:'number',
    values:'',
    readonly:false,
    layout:'col',
  },
  { 
    name:'01_Number_of_applications_of_tyoe_label',/*  */
    label: "of type",
    type:'label',
    layout:'col ',
  },
  {
    name:'01_Number_of_applications_of_tyoe',
    label:'',
    type:'text',
    values:'',
    readonly:false,
    layout:'col ',
  },
  /*  */

  /*  */
  {
    name:'21_comments_label',
    label:'Comments',
    type:'label',
    layout:'col 12 clear',
  },
  {
    name:'21_comments',
    label:'',
    type:'text_area',
    values:'',
    readonly:false,
    layout:'col s12',
},
  //end of record
]

const generate = () =>{
return JSON.parse(JSON.stringify(fields)) 
}

const exportSchema = {
  "01_trials_scheduled_civil":{
    "label": "1. Number of trials scheduled (Civil):",
    "key": "01_trials_scheduled_civil"
  },
  "01_trials_scheduled_commercial":{
    "label": "1. Number of trials scheduled (commercial):",
    "key": "01_trials_scheduled_commercial"
  },
  "02_trials_completed_disposed_civil":{
    "label": "2. Number of trials completed/disposed (civil):",
    "key": "02_trials_completed_disposed_civil"
  },
  "02_trials_completed_disposed_commercial":{
    "label": "2. Number of trials completed/disposed (commercial)",
    "key": "02_trials_completed_disposed_commercial"
  },
  "02_b_method_of_completion_of_each_trial":{
    "label": "2 (b) Method of completion of each trial in 2(a)",
    "key": "02_b_method_of_completion_of_each_trial"
  },
  "3_a_number_of_trials_adjourned_civil":{
    "label": "3 (a) Number of trials adjourned (Civil)",
    "key": "3_a_number_of_trials_adjourned_civil"
  },
  "3_a_number_of_trials_adjourned_commercial":{
    "label": "3 (a) Number of trials adjourned (Commercial)",
    "key": "3_a_number_of_trials_adjourned_commercial"
  },
  "3_b_how_many_adjourned_trials_were_part_heard_civil":{
    "label": "3 (b) How many <b>of the adjourned trials</b> were part heard (Civil)? ",
    "key": "3_b_how_many_adjourned_trials_were_part_heard_civil"
  },
  "3_b_how_many_adjourned_trials_were_part_heard_commercial":{
    "label": "3 (b) How many <b>of the adjourned trials</b> were part heard (Commercial)",
    "key": "3_b_how_many_adjourned_trials_were_part_heard_commercial"
  },
  "3_c_reasons_for_adjournments":{
    "label": "3 (C) Reasons for adjournments",
    "key": "3_c_reasons_for_adjournments"
  },
  "3_e_what_were_the_primary_reasons_for_the_further_adjournment":{
    "label": "&nbsp; &nbsp; (e) What were the primary reasons for the further adjournments?",
    "key": "3_e_what_were_the_primary_reasons_for_the_further_adjournment"
  },
  "3_d_how_many_trials_were_adjourned":{
    "label": "&nbsp; &nbsp; (d) How many trials were adjourned (more than once)?",
    "key": "3_d_how_many_trials_were_adjourned"
  },
  "how_many_trials_have_lasted":{
    "label": "4. How many trials have lasted: (Please clearly indicate your responses)",
    "key": "how_many_trials_have_lasted"
  },
  "01_number_of_written_judgments_delivered":{
    "label": "1. Number of written judgments delivered",
    "key": "01_number_of_written_judgments_delivered"
  },
  "02_number_of_oral_judgments_delivered":{
    "label": "2. Number of oral judgments delivered",
    "key": "02_number_of_oral_judgments_delivered"
  },
  "01_Number_of_matters_scheduled_listed":{
    "label": "1. Number of open court and chamber matters scheduled/listed",
    "key": "01_Number_of_matters_scheduled_listed"
  },
  "02_Number_of_matters_where_decisions_were_reserved":{
    "label": "2. Number of matters where decisions were reserved",
    "key": "02_Number_of_matters_where_decisions_were_reserved"
  },
  "03_Number_of_oral_decisions_delivered":{
    "label": "3. Number of oral decisions delivered",
    "key": "03_Number_of_oral_decisions_delivered"
  },
  "04_Number_of_written_decisions_delivered":{
    "label": "4. Number of written decisions delivered",
    "key": "04_Number_of_written_decisions_delivered"
  },
  "05_a_Reasons_for_adjournment_of_matters":{
    "label": "5. (a) Reasons for adjournment of matters <br><span class=\"red-text\">(Enter values only for the first adjournment)</span>",
    "key": "05_a_Reasons_for_adjournment_of_matters"
  },
  "5_b_what_were_the_primary_reasons_for_any_further_adjournments":{
    "label": "&nbsp; &nbsp; (b) What were the primary reasons for any further adjournments",
    "key": "5_b_what_were_the_primary_reasons_for_any_further_adjournments"
  },
  "06_number_of_matters_completed_disposed_of":{
    "label": "6. Number of matters completed/disposed",
    "key": "06_number_of_matters_completed_disposed_of"
  },
  "1_Number_of_Divorce_matters_matrimonial_applications_scheduled_listed":{
    "label": "1. Number of Divorce matters/Matrimonial applications scheduled/listed",
    "key": "1_Number_of_Divorce_matters_matrimonial_applications_scheduled_listed"
  },
  "2_Number_of_Divorce_matters_Matrimonial_applications_adjourned":{
    "label": "2. Number of Divorce matters/ Matrimonial applications adjourned",
    "key": "2_Number_of_Divorce_matters_Matrimonial_applications_adjourned"
  },
  "3_Number_of_Decrees_Nisi_granted":{
    "label": "3. Number of Decrees Nisi granted",
    "key": "3_Number_of_Decrees_Nisi_granted"
  },
  "4_Number_of_decrees_absolute":{
    "label": "4. Number of Decrees Absolute ",
    "key": "4_Number_of_decrees_absolute"
  },
  "5_Number_of_Ancillary_matters_scheduled_listed":{
    "label": "5. Number of Ancillary matters scheduled/listed",
    "key": "5_Number_of_Ancillary_matters_scheduled_listed"
  },
  "6_Number_of_Ancillary_matters_adjourned":{
    "label": "6. Number of Ancillary matters adjourned",
    "key": "6_Number_of_Ancillary_matters_adjourned"
  },
  "07_Method_of_disposal_of_Ancillary_matters":{
    "label": "7. Method of disposal of Ancillary matters ",
    "key": "07_Method_of_disposal_of_Ancillary_matters"
  },
  "08_Reasons_for_adjournment_for_all_Divorce_matters_Divorce_ancillary_etc":{
    "label": "8. Reasons for adjournment for all Divorce matters (Divorce, ancillary etc): <br> <span class=\"red-text\">(Enter values only for the first adjournment)</span>",
    "key": "08_Reasons_for_adjournment_for_all_Divorce_matters_Divorce_ancillary_etc"
  },
  "8_b_What_wer_the_primary_reason_for_any_further_adjournments":{
    "label": "(b) What were the primary reasons for any further adjournments?",
    "key": "8_b_What_wer_the_primary_reason_for_any_further_adjournments"
  },
  "01_Number_of_applications_without_notice_dealt_with":{
    "label": "1. Number of applications without notice dealt with",
    "key": "01_Number_of_applications_without_notice_dealt_with"
  },
  "01_Number_of_applications_dealt_with_in_this_regard":{
    "label": "1. Number of applications dealt with in review/administration of estates and probates",
    "key": "01_Number_of_applications_dealt_with_in_this_regard"
  },
  "01_Number_of_applications":{
    "label": "1. Number of other applications",
    "key": "01_Number_of_applications"
  },
  "01_Number_of_applications_of_tyoe":{
    "label": "of type",
    "key": "01_Number_of_applications_of_tyoe"
  },
  "21_comments":{
    "label": "Comments",
    "key": "21_comments"
  }
}


const populate = (data) => {
  fields.forEach(item => {
  let key = item.name
  let v = data[key]
  
  if (item.dataType === 'Object'){
    v = item.options.find(a => a.prop === v)
  }
   if(data[key]) {
    item.values = v
  }
})

return fields
}


const populateX = (data) => {

let y = fields.map(item => {
  let x = {...item}
  x.values =  data[item.name]
  return x
})
return y
}

export default {
fields, generate, populate, populateX, exportSchema
}